

































import { Vue, Component, Watch } from 'vue-property-decorator'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindPerfilUseCase, DeletePerfilUseCase } from '@/usecases'
import { Page, Pageable, Perfil } from '@/models'
import axios, { CancelToken, CancelTokenSource } from 'axios'
import { DataOptions } from 'vuetify'

@Component({
	components: {
		DataTableDeCrud,
	},
})
export default class TelaDePerfis extends Vue {
	headers = [{ text: 'Nome', value: 'nome' }]

	totalRegistros = -1
	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	carregando = false

	busca = ''

	findUseCase = new FindPerfilUseCase()
	deleteUseCase = new DeletePerfilUseCase()
	cancelToken: CancelTokenSource | null = null

	perfis: Perfil[] = []

	created() {
		this.carregar()
	}

	get filtrosInicias() {
		return { busca: '' }
	}

	async carregar() {
		try {
			this.carregando = true
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()
			const paginaDePerfis = await this.findUseCase.findAll({
				busca: this.busca || undefined,
				page: this.paginacao.page - 1,
				size: this.paginacao.itemsPerPage,
				axiosConfig: {
					cancelToken: this.cancelToken.token,
				},
			})
			this.perfis = paginaDePerfis.content
			this.totalRegistros = paginaDePerfis.totalElements
		} catch (error) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	async buscarPagina(paginavel: Pageable, parametros: {
		busca?: string
	}, cancelToken: CancelToken): Promise<Page<Perfil>> {
		const pagina = await this.findUseCase.findAll({
			...parametros,
			...paginavel,
		}, {
			cancelToken,
		})
		this.perfis = pagina.content
		return pagina
	}

	get itensFormatados(): DisplayPerfil[] {
		return this.itens.map(item => ({
			...item,
		}))
	}

	get itens() {
		return this.perfis
	}

	async removerPerfil(indice: number) {
		const perfil = this.itens[indice]
		if (!perfil.id) return
		try {
			await this.deleteUseCase.delete(perfil.id)
			this.perfis = this.perfis.filter(({ id }) => id !== perfil.id)
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao = this.carregar

	@Watch('busca', { immediate: true })
	onChangeBusca() {
		this.paginacao = {
			...this.paginacao,
			page: 0,
		}
		this.carregar()
	}
}

export interface DisplayPerfil extends Perfil {}
